const routes = [

	
	//---- "Account Admin" pages
	{
		path: '/account-admin',
		name: "account-admin-root", 
		component: () => import("/account-admin/index.vue"),
		// meta: { layout: "account-admin", pageTitle: "Account Admin", kbFile: "account-admin", kbTitle: "Account Admin" }
		meta: { layout: "primary", layoutType: "account-admin", layoutContainer: "none", pageTitle: "Account Admin", kbFile: "account-admin", kbTitle: "Account Admin" }
	},

	{
		path: '/account-admin/:accountId',
		name: "account-admin-home", 
		component: () => import("/account-admin/index.vue"),
		//meta: { layout: "account-admin", pageTitle: "Account Admin", kbFile: "account-admin", kbTitle: "Account Admin" }
		meta: { layout: "primary", layoutType: "account-admin", layoutContainer: "none", parentRouteName: "account-admin-root", pageTitle: "Account details", kbFile: "account-admin", kbTitle: "Account Admin" }
	},

	{
		path: '/account-admin/:accountId/user/:id', 
		name: "account-admin-user-edit", 
		component: () => import("/account-admin/user.vue"),
		meta: { layout: "primary", layoutType: "account-admin", layoutContainer: "none", parentRouteName: "account-admin-home", pageTitle: "Person - {personName}", breadcrumbLabel: "Person", kbFile: "account-admin", kbTitle: "Account Admin" }
	},
	{
		path: '/account-admin/:accountId/user/:id/access', 
		name: "account-admin-user-access", 
		component: () => import("/account-admin/user-access.vue"),
		meta: { layout: "primary", layoutType: "account-admin", layoutContainer: "none", parentRouteName: "account-admin-user-edit", pageTitle: "Permissions - {personName}", breadcrumbLabel: "Permissions", kbFile: "account-admin", kbTitle: "Account Admin" }
	},
	{
		path: '/account-admin/:accountId/users/new',  
		name: "account-admin-user-new", 
		component: () => import("/account-admin/user.vue"),
		meta: { layout: "primary", layoutType: "account-admin", layoutContainer: "none", parentRouteName: "account-admin-home", pageTitle: "Register new person", kbFile: "account-admin", kbTitle: "Account Admin" }
	},


	//TODO: Obsolete. Remove
	// { 
	// 	path: '/account-admin/account/:id/organisation-roles', 
	// 	name: "AccountAdminAccountOrganisationRoles",
	// 	component: () => import("/system-admin/account/organisation-roles.vue"),
	// 	meta: { layout: "primary", section: "system-admin", pageTitle: "Account & People > Organisation Roles" }
	// },



]


export default routes;